import {
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
  UUID,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const UpdateProspectLeadIdParameters = z.object({
  userId: HealthcareUserId,
  sessionId: HealthcareSessionId,
  domainUserId: DomainUserId.optional(),
  domainSessionId: DomainSessionId.optional(),
  leadId: UUID,
});

export type UpdateProspectLeadIdParameters = z.infer<
  typeof UpdateProspectLeadIdParameters
>;
